import { MinValueError } from '../../validation/errors/min-value-error'
import { type FieldValidation } from '../../validation/protocols/field-validation'

export class MinValueValidation implements FieldValidation {
  readonly field: string
  private readonly minValue: number

  constructor (field: string, minValue: number) {
    this.field = field
    this.minValue = minValue
  }

  validate (value: string): Error | null {
    if (+value < this.minValue) return new MinValueError(this.minValue)
    return null
  }
}
